module.exports = __webpack_public_path__ + "img/94.97ad7b4f.webp";